<template>
    <div id="entire_dates_and_days_component">
        <li
            class="calendar-day"
            :class="{
                'calendar-day--not-current': !isCurrentMonth,
                'calendar-day--today': isToday
            }"
        >
            <span>{{ label }}</span>
        </li>
    </div>
</template>

<script>
    import dayjs from "dayjs";

    export default {
        name: "CalendarMonthDayItem",

        props: {
            day: {
                type: Object,
                required: true
            },

            isCurrentMonth: {
                type: Boolean,
                default: false
            },

            isToday: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            label() {
                return dayjs(this.day.date).format("D");
            }
        }
    };
</script>

<style lang="scss" scoped>
   #entire_dates_and_days_component{
        width: 100%;
        height: 100%;

        .calendar-day {
            span {
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
                align-items: center;
                font-family:satoshi, $poppins !important;
                font-size: 0.6em;
                font-weight: 600;
                color: $dimestDark;
                flex-direction: column;

            }
        }

        // .calendar-day--not-current {
        //     span {
        //         opacity: 0.1 !important;
        //     }
        // }        

        .calendar-day--today {
            span{
                position: absolute;
                color: $pureWhite !important;
                font-weight: 800;
                width: 2.5em !important;
                height: 2.5em !important;
                border-radius: 50%;
                background: $mainBlue !important;
            }
        }

    }

</style>
